export enum TaskState {
  CONFIRMED = "CONFIRMED",
  OPEN = "OPEN"
}
